import React from "react";

import { MenuItems, MenuWrapper, BurgerWrapper } from "./styles.Menu";
import { LegalLinks } from "../header/Header";

import CloseIcon from "../../assets/Close-X.svg";
import BurgerIcon from "../../assets/Burger.svg";

import { table_of_contents } from "../../App";
import { ContentWrapper } from "../content/styles.Content";

interface MenuButtonProps {
  menuVisible: boolean;
  onClick?: any;
}

export const MenuButton: React.FC<MenuButtonProps> = ({
  menuVisible,
  onClick,
}) => {
  return (
    <BurgerWrapper onClick={onClick}>
      <img src={menuVisible ? CloseIcon : BurgerIcon} alt="Open/Close Menu" />
    </BurgerWrapper>
  );
};

interface MenuProps {
  isVisible?: boolean;
  backgroundColor?: string;
  currentAnchor?: string;
  handleClick?: any;
}

export const Menu: React.FC<MenuProps> = ({
  isVisible: navbar,
  backgroundColor,
  currentAnchor,
  handleClick,
}) => {
  const titles = Object.keys(table_of_contents);
  const anchors = Object.values(table_of_contents);

  const getCurrent = (
    title: string,
    index: number,
    currentAnchor: string | undefined
  ) => {
    if (anchors[index] === `#${currentAnchor}`) {
      return (
        <strong>
          <a href={anchors[index]}>{title}</a>
        </strong>
      );
    } else {
      return <a href={anchors[index]}>{title}</a>;
    }
  };

  return (
    <MenuWrapper isVisible={navbar} background={backgroundColor}>
      <ContentWrapper bigMargins={true}>
        <MenuItems>
          <nav>
            <ul>
              {titles.map((title, i) => (
                <li key={anchors[i]} onClick={handleClick}>
                  {getCurrent(title, i, currentAnchor)}
                </li>
              ))}
            </ul>
          </nav>
        </MenuItems>
        <LegalLinks className={"imprintMobile"} />
      </ContentWrapper>
    </MenuWrapper>
  );
};
